export function getToken() {
  const user = localStorage.getItem("User");
  if (user) {
    try {
      const parsedToken = JSON.parse(user); // If it's supposed to be JSON
      return parsedToken.jwt_token;
    } catch (error) {
      console.error("Failed to parse jwt_token:", error);
      return "";
    }
  } else {
    console.error("jwt_token not found in localStorage");
    return "";
  }
}


export const setCookies = (name, value) => {
  $cookies.set(name, value, '24h', {
    domain: '.vectolabs.com',
    secure: true,
    sameSite: 'Lax'
    // httpOnly is ignored in JS; remove or move to server-side.
  });

  const existing = getCookies(name);
  if (!existing) {
    localStorage.setItem(name, value);
    sessionStorage.setItem(name, value);
  }

  return value;
};

export const getCookies = (name) => {
  let token = $cookies.get(name);
  if (!token) {
    token = localStorage.getItem(name);
  }
  if (!token) {
    token = sessionStorage.getItem(name);
  }
  return token || null;
};

export const removeCookies = (name, value) => {
  return $cookies.remove(name, value);
}

export async function refreshToken(session) {
  const obj = {
    service: "streetlight",
    key: session,
  };

  try {
    const response = await fetch("https://solution.vectolabs.com/api/auth/refresh", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(obj),
    });

    if (!response.ok) {
      throw new Error('error refresh token')
    }

    const res = await response.json();

    setCookies('session', res.session)
    setCookies('token', res.token)
    return true;
  } catch (error) {
    console.error(error)
    removeCookies('token')
    removeCookies('session')
    removeCookies('userName')
    removeCookies('TenantID')
    removeCookies('userTypeID')
    removeCookies('User')
    removeCookies('user')
    return false;
  }
}

export const jwtDecode = (token) => {
  return JSON.parse(atob(token.split(".")[1]))
}

export const formatTo2Decimal = (data) => {
  if (Array.isArray(data)) {
    return data.map(num => {
      if (num === null) return null;
      return Number(num.toFixed(2));
    });
  }

  // Optional: handle single value (not array)
  if (data === null) return null;
  return Number(data.toFixed(2));
};

export const GetAuthorization = () => {
  const token = getCookies('token')
  if (!token) {
    return false
  }

  const { AccessLevelID } = jwtDecode(token)
  return AccessLevelID === 1 || AccessLevelID === 2
}

export const CleanUpCookies = () => {
  for (const cookie of $cookies.keys()) {
    $cookies.remove(cookie)
  }
}


const utils = {
  jwtDecode,
  getToken,
  setCookies,
  getCookies,
  removeCookies,
  refreshToken,
  formatTo2Decimal,
  GetAuthorization,
};

export default utils;
